export default __webpack_public_path__ + "static/media/star-full.5a652457.svg";